module.exports = __webpack_public_path__ + "img/heffin-logo.5bdecef6.jpg";